// Action Types
export const SETVOICE = "SETVOICE";
export const SETCONSISTENCY = "SETCONSISTENCY";
export const HIGHLIGHTVOICEKEY = "HIGHLIGHTVOICEKEY";
export const SET_SLIDER_VALUE = "SET_SLIDER_VALUE";
export const SET_MIDI_FLAG = "SET_MIDI_FLAG";
export const SET_NOTE_MIDI_NUM = "SET_NOTE_MIDI_NUM";
export const SET_MUSIC_THEORY_FORMULA = "SET_MUSIC_THEORY_FORMULA";
export const SET_WIDGET_STARTED = "SET_WIDGET_STARTED";
export const SET_TONES_MT = "SET_TONES_MT";
export const SET_GHOST_TONES_MT = "SET_GHOST_TONES_MT";
export const SET_SHOW_GHOST = "SET_SHOW_GHOST";
export const SET_SONGS_ARRAY = "SET_SONGS_ARRAY";
export const SET_NOTES = "SET_NOTES";
export const SET_ALLNOTES = "SET_ALLNOTES";
export const SET_PIANO_LABELS = "SET_PIANO_LABELS";
export const SET_LABELS = "SET_LABELS";
export const SET_SONG_MODAL = "SET_SONG_MODAL";
export const SET_BUFFER_LOADING = "SET_BUFFER_LOADING";
export const SET_AUTO_LABEL = "SET_AUTO_LABEL";
export const SET_APPLY_GHOST = "SET_APPLY_GHOST";
export const SET_CURRENT_SONG = "SET_CURRENT_SONG";
export const SET_CURRENT_SONG_NAME = "SET_CURRENT_SONG_NAME";
export const SET_CURRENT_SONG_INDEX = "SET_CURRENT_SONG_INDEX";
export const SET_SCALE_EDITING = "SET_SCALE_EDITING";
export const SET_USER_GHOST = "SET_USER_GHOST";
export const SET_OPEN_SECTION_MODAL = "SET_OPEN_SECTION_MODAL";
export const SET_CURRENT_SECTION_NAME = "SET_CURRENT_SECTION_NAME";
export const SET_BASE_NOTE = "SET_BASE_NOTE";
export const SET_MUSIC_THEORY_MIDI_NUMS = "SET_MUSIC_THEORY_MIDI_NUMS";
export const SET_WRONG_MIC_INPUT = "SET_WRONG_MIC_INPUT";
export const SET_WRONG_MIDI_INPUT = "SET_WRONG_MIDI_INPUT";
export const SET_USER_SELECTED_LABELS = "SET_USER_SELECTED_LABELS";
export const SET_CUSTOM_VOCAL_TONE = "SET_CUSTOM_VOCAL_TONE";
export const SET_SHOW_RANGE = "SET_SHOW_RANGE";
export const SET_DEFAULT_MT = "SET_DEFAULT_MT";
export const SET_SUSTAIN_PEDAL = "SET_SUSTAIN_PEDAL";
export const SET_SUSTAINED_NOTES = "SET_SUSTAINED_NOTES";
export const SET_SUSTAIN_PEDAL_NTTOGGLE = "SET_SUSTAIN_PEDAL_NTTOGGLE";

// Action Creators
export const setVoice = (value = false) => ({
  type: SETVOICE,
  payload: value,
});

export const setConsistency = (value = false) => ({
  type: SETCONSISTENCY,
  payload: value,
});

export const highlightVoiceKey = (value = 0) => ({
  type: HIGHLIGHTVOICEKEY,
  payload: value,
});

export const setMicValue = (value) => {
  return {
    type: SET_SLIDER_VALUE,
    payload: value,
  };
};
export const setEnableMidiFlag = (value) => {
  return {
    type: SET_MIDI_FLAG,
    payload: value,
  };
};
export const setNoteMidiNum = (value) => {
  return {
    type: SET_NOTE_MIDI_NUM,
    payload: value,
  };
};
export const setMusicThoeryFormula = (value) => {
  return {
    type: SET_MUSIC_THEORY_FORMULA,
    payload: value,
  };
};
export const setWidgetStarted = (value) => {
  return {
    type: SET_WIDGET_STARTED,
    payload: value,
  };
};

export const setTonesMT = (value) => {
  return {
    type: SET_TONES_MT,
    payload: value,
  };
};

export const setGhostTonesMT = (value) => {
  console.log(value);
  return {
    type: SET_GHOST_TONES_MT,
    payload: value,
  };
};

export const setShowGhost = (value) => {
  return {
    type: SET_SHOW_GHOST,
    payload: value,
  };
};

export const setSongsArray = (value) => {
  localStorage.setItem("songsArray", JSON.stringify(value));
  return {
    type: SET_SONGS_ARRAY,
    payload: value,
  };
};

export const setNotes = (value) => {
  return {
    type: SET_NOTES,
    payload: value,
  };
};

export const setAllNotes = (value) => {
  return {
    type: SET_ALLNOTES,
    payload: value,
  };
};

export const setPianoLabels = (value) => {
  return {
    type: SET_PIANO_LABELS,
    payload: value,
  };
};

export const setLabels = (value) => {
  return {
    type: SET_LABELS,
    payload: value,
  };
};

export const setSongModal = (value) => {
  return {
    type: SET_SONG_MODAL,
    payload: value,
  };
};

export const setBufferLoading = (value) => {
  return {
    type: SET_BUFFER_LOADING,
    payload: value,
  };
};

export const setAutoLabel = (value) => {
  return {
    type: SET_AUTO_LABEL,
    payload: value,
  };
};

export const setApplyGhost = (value) => {
  return {
    type: SET_APPLY_GHOST,
    payload: value,
  };
};

export const setCurrentSong = (value) => {
  return {
    type: SET_CURRENT_SONG,
    payload: value,
  };
};

export const setCurrentSongName = (value) => {
  return {
    type: SET_CURRENT_SONG_NAME,
    payload: value,
  };
};
export const setCurrentSongIndex = (value) => {
  return {
    type: SET_CURRENT_SONG_INDEX,
    payload: value,
  };
};

export const setScaleEditing = (value) => {
  return {
    type: SET_SCALE_EDITING,
    payload: value,
  };
};
export const setUserGhost = (value) => {
  return {
    type: SET_USER_GHOST,
    payload: value,
  };
};
export const setNewSectionModal = (value) => {
  return {
    type: SET_OPEN_SECTION_MODAL,
    payload: value,
  };
};

export const setCurrentSectionName = (value) => {
  return {
    type: SET_CURRENT_SECTION_NAME,
    payload: value,
  };
};

export const setBaseNote = (value) => {
  return {
    type: SET_BASE_NOTE,
    payload: value,
  };
};
export const setMusicTheoryMidiNums = (value) => {
  return {
    type: SET_MUSIC_THEORY_MIDI_NUMS,
    payload: value,
  };
};
export const setWrongMicInput = (value) => {
  return {
    type: SET_WRONG_MIC_INPUT,
    payload: value,
  };
};
export const setWrongMidiInput = (value) => {
  return {
    type: SET_WRONG_MIDI_INPUT,
    payload: value,
  };
};

export const setUserSelectedLabels = (value) => {
  return {
    type: SET_USER_SELECTED_LABELS,
    payload: value,
  };
};
export const setCustomVocalTone = (value) => {
  return {
    type: SET_CUSTOM_VOCAL_TONE,
    payload: value,
  };
};
export const setShowRange = (value) => {
  return {
    type: SET_SHOW_RANGE,
    payload: value,
  };
};
export const setDefaultMt = (value) => {
  return {
    type: SET_DEFAULT_MT,
    payload: value,
  };
};

export const setSustainPedal = (value) => {
  return {
    type: SET_SUSTAIN_PEDAL,
    payload: value,
  };
};

export const setSustainedNotes = (value) => {
  return {
    type: SET_SUSTAINED_NOTES,
    payload: value,
  };
};

export const setSustainPedalNTToggle = (value) => {
  return {
    type: SET_SUSTAIN_PEDAL_NTTOGGLE,
    payload: value,
  };
};